const ua = navigator.userAgent;
const av = navigator.appVersion;

const isFF = ~ua.indexOf('Firefox/') && !~ua.indexOf('Seamonkey/');
const isLinux = av.indexOf('Linux') !== -1 && av.indexOf('Android') === -1;

export const isSafari = ~ua.indexOf('Safari/') && !~ua.indexOf('Chrome/') && !~ua.indexOf('Chromium/');

export const sbrowserEnabled = () => (isSafari || isFF) && !isLinux;
